import { useEffect, createContext, useRef, useState } from "react";
import LoadScripts from '../LoadScripts'
import Layout from './Layout'
import Footer from './Footer'
export const LanguageContext = createContext();

function Publisher() {
    // const [language, setLanguage] = useState("en");
    
    return (
        <>
            {/* <LanguageContext.Provider value={{ language, setLanguage }}> */}
            {/* <Layout /> */}
            <LoadScripts />
            <section className="blog-content-section py-50 py-lg-80 py-xxl-100">
                <div className="container">
                    <div className="row align-items-start position-relative">
                        <div className="social-share-icons d-flex align-items-center gap-30">
                        </div>
                        <div className="col-lg-9">
                            {/* blog-inner-content */}
                            <div className="blog-content-image mt-50 mb-40 mt-lg-100 mb-lg-60 mx-lg-n100 position-relative overflow-hidden">
                                <picture>
                                    <source
                                        media="(max-width:575px)"
                                        srcSet="assets/images/blog-content-image-2.png"
                                    />
                                    <img
                                        
                                        className="img-fluid"
                                        alt="img"
                                    />
                                </picture>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/*Blog-content Section ======================*/}
            <section className="blog-section blog-vertical pb-50 pb-lg-80">
                <div className="container">
                    <div className="row gy-4 gy-lg-0 align-items-lg-end justify-content-lg-between mb-30 mb-lg-70">
                        <div className="col-lg-4">
                            {/* section-title */}
                        </div>
                    </div>
                    {/* row */}
                    <div className="blog-content-wrapper position-relative">
                        <div className="ellipse-image-1">
                            <img src="assets/images/home-1/ellipse-1.png" alt="ellipse-1" />
                        </div>
                        <div className="swiper blog-2-swiper p-10">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide">
                                    <div className="blog-content">
                                        <div className="blog-content-2 custom-inner-bg">
                                            <div className="row gy-4 align-items-center justify-content-between">
                                                <div className="col-12">
                                                    <div className="blog-image">
                                                        <img
                                                            src="assets/images/home-2/blog-image-1.jpg"
                                                            className="img-fluid"
                                                            alt="img"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="blog-left-content">
                                                        <p>
                                                            <span className="calendar me-10">
                                                                <svg width={16} height={17}>
                                                                    <use xlinkHref="#calendar" />
                                                                </svg>
                                                            </span>
                                                            09 Aug 2023
                                                        </p>
                                                        <h2 className="blog-link fs-4 fw-bold">
                                                            <a
                                                                className="text-decoration-none"
                                                                href="blog-single-1.html"
                                                            >
                                                                Unveils Star-Studded Lineup for Epic Comeback Event!
                                                            </a>
                                                        </h2>
                                                        <p className="py-20 mb-3 mb-lg-0">
                                                            Get ready for a musical extravaganza like never before
                                                            as Harmonia Music ...
                                                        </p>
                                                        <div>
                                                            <a
                                                                href="blog-single-1.html"
                                                                className="download-link d-flex align-items-center gap-30"
                                                                aria-label="buttons"
                                                            >
                                                                Read more
                                                                <span className="ticket-arrow arrow-up-right">
                                                                    <svg width={32} height={32}>
                                                                        <use xlinkHref="#arrow-up-right" />
                                                                    </svg>
                                                                </span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    {/* left-content */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* blog-content */}
                                </div>
                                {/* swiper-slide*/}
                                <div className="swiper-slide">
                                    <div className="blog-content">
                                        <div className="blog-content-2 custom-inner-bg">
                                            <div className="row gy-4 align-items-center justify-content-between">
                                                <div className="col-12">
                                                    <div className="blog-image">
                                                        <img
                                                            src="assets/images/home-2/blog-image-2.jpg"
                                                            className="img-fluid"
                                                            alt="img"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="blog-left-content">
                                                        <p>
                                                            <span className="calendar me-10">
                                                                <svg width={16} height={17}>
                                                                    <use xlinkHref="#calendar" />
                                                                </svg>
                                                            </span>
                                                            09 Aug 2023
                                                        </p>
                                                        <h2 className="blog-link fs-4 fw-bold">
                                                            <a
                                                                className="text-decoration-none"
                                                                href="blog-single-1.html"
                                                            >
                                                                Unveils Star-Studded Lineup for Epic Comeback Event!
                                                            </a>
                                                        </h2>
                                                        <p className="py-20 mb-3 mb-lg-0">
                                                            Get ready for a musical extravaganza like never before
                                                            as Harmonia Music ...
                                                        </p>
                                                        <div>
                                                            <a
                                                                href="blog-single-1.html"
                                                                className="download-link d-flex align-items-center gap-30"
                                                                aria-label="buttons"
                                                            >
                                                                Read more
                                                                <span className="ticket-arrow arrow-up-right">
                                                                    <svg width={32} height={32}>
                                                                        <use xlinkHref="#arrow-up-right" />
                                                                    </svg>
                                                                </span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    {/* left-content */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* blog-content */}
                                </div>
                                {/* swiper-slide*/}
                                <div className="swiper-slide">
                                    <div className="blog-content">
                                        <div className="blog-content-2 custom-inner-bg">
                                            <div className="row gy-4 align-items-center justify-content-between">
                                                <div className="col-12">
                                                    <div className="blog-image">
                                                        <img
                                                            src="assets/images/home-2/blog-image-3.jpg"
                                                            className="img-fluid"
                                                            alt="img"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="blog-left-content">
                                                        <p>
                                                            <span className="calendar me-10">
                                                                <svg width={16} height={17}>
                                                                    <use xlinkHref="#calendar" />
                                                                </svg>
                                                            </span>
                                                            09 Aug 2023
                                                        </p>
                                                        <h2 className="blog-link fs-4 fw-bold">
                                                            <a
                                                                className="text-decoration-none"
                                                                href="blog-single-1.html"
                                                            >
                                                                Unveils Star-Studded Lineup for Epic Comeback Event!
                                                            </a>
                                                        </h2>
                                                        <p className="py-20 mb-3 mb-lg-0">
                                                            Get ready for a musical extravaganza like never before
                                                            as Harmonia Music ...
                                                        </p>
                                                        <div>
                                                            <a
                                                                href="blog-single-1.html"
                                                                className="download-link d-flex align-items-center gap-30"
                                                                aria-label="buttons"
                                                            >
                                                                Read more
                                                                <span className="ticket-arrow arrow-up-right">
                                                                    <svg width={32} height={32}>
                                                                        <use xlinkHref="#arrow-up-right" />
                                                                    </svg>
                                                                </span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    {/* left-content */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* blog-content */}
                                </div>
                                {/* swiper-slide*/}
                                <div className="swiper-slide">
                                    <div className="blog-content">
                                        <div className="blog-content-2 custom-inner-bg">
                                            <div className="row gy-4 align-items-center justify-content-between">
                                                <div className="col-12">
                                                    <div className="blog-image">
                                                        <img
                                                            src="assets/images/home-2/blog-image-2.jpg"
                                                            className="img-fluid"
                                                            alt="img"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="blog-left-content">
                                                        <p>
                                                            <span className="calendar me-10">
                                                                <svg width={16} height={17}>
                                                                    <use xlinkHref="#calendar" />
                                                                </svg>
                                                            </span>
                                                            09 Aug 2023
                                                        </p>
                                                        <h2 className="blog-link fs-4 fw-bold">
                                                            <a
                                                                className="text-decoration-none"
                                                                href="blog-single-1.html"
                                                            >
                                                                Unveils Star-Studded Lineup for Epic Comeback Event!
                                                            </a>
                                                        </h2>
                                                        <p className="py-20 mb-3 mb-lg-0">
                                                            Get ready for a musical extravaganza like never before
                                                            as Harmonia Music ...
                                                        </p>
                                                        <div>
                                                            <a
                                                                href="blog-single-1.html"
                                                                className="download-link d-flex align-items-center gap-30"
                                                                aria-label="buttons"
                                                            >
                                                                Read more
                                                                <span className="ticket-arrow arrow-up-right">
                                                                    <svg width={32} height={32}>
                                                                        <use xlinkHref="#arrow-up-right" />
                                                                    </svg>
                                                                </span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    {/* left-content */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* blog-content */}
                                </div>
                                {/* swiper-slide*/}
                                <div className="swiper-slide">
                                    <div className="blog-content">
                                        <div className="blog-content-2 custom-inner-bg">
                                            <div className="row gy-4 align-items-center justify-content-between">
                                                <div className="col-12">
                                                    <div className="blog-image">
                                                        <img
                                                            src="assets/images/home-2/blog-image-1.jpg"
                                                            className="img-fluid"
                                                            alt="img"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="blog-left-content">
                                                        <p>
                                                            <span className="calendar me-10">
                                                                <svg width={16} height={17}>
                                                                    <use xlinkHref="#calendar" />
                                                                </svg>
                                                            </span>
                                                            09 Aug 2023
                                                        </p>
                                                        <h2 className="blog-link fs-4 fw-bold">
                                                            <a
                                                                className="text-decoration-none"
                                                                href="blog-single-1.html"
                                                            >
                                                                Unveils Star-Studded Lineup for Epic Comeback Event!
                                                            </a>
                                                        </h2>
                                                        <p className="py-20 mb-3 mb-lg-0">
                                                            Get ready for a musical extravaganza like never before
                                                            as Harmonia Music ...
                                                        </p>
                                                        <div>
                                                            <a
                                                                href="blog-single-1.html"
                                                                className="download-link d-flex align-items-center gap-30"
                                                                aria-label="buttons"
                                                            >
                                                                Read more
                                                                <span className="ticket-arrow arrow-up-right">
                                                                    <svg width={32} height={32}>
                                                                        <use xlinkHref="#arrow-up-right" />
                                                                    </svg>
                                                                </span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    {/* left-content */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* blog-content */}
                                </div>
                                {/* swiper-slide*/}
                                <div className="swiper-slide">
                                    <div className="blog-content">
                                        <div className="blog-content-2 custom-inner-bg">
                                            <div className="row gy-4 align-items-center justify-content-between">
                                                <div className="col-12">
                                                    <div className="blog-image">
                                                        <img
                                                            src="assets/images/home-2/blog-image-2.jpg"
                                                            className="img-fluid"
                                                            alt="img"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="blog-left-content">
                                                        <p>
                                                            <span className="calendar me-10">
                                                                <svg width={16} height={17}>
                                                                    <use xlinkHref="#calendar" />
                                                                </svg>
                                                            </span>
                                                            09 Aug 2023
                                                        </p>
                                                        <h2 className="blog-link fs-4 fw-bold">
                                                            <a
                                                                className="text-decoration-none"
                                                                href="blog-single-1.html"
                                                            >
                                                                Unveils Star-Studded Lineup for Epic Comeback Event!
                                                            </a>
                                                        </h2>
                                                        <p className="py-20 mb-3 mb-lg-0">
                                                            Get ready for a musical extravaganza like never before
                                                            as Harmonia Music ...
                                                        </p>
                                                        <div>
                                                            <a
                                                                href="blog-single-1.html"
                                                                className="download-link d-flex align-items-center gap-30"
                                                                aria-label="buttons"
                                                            >
                                                                Read more
                                                                <span className="ticket-arrow arrow-up-right">
                                                                    <svg width={32} height={32}>
                                                                        <use xlinkHref="#arrow-up-right" />
                                                                    </svg>
                                                                </span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    {/* left-content */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* blog-content */}
                                </div>
                                {/* swiper-slide*/}
                            </div>
                            {/* swiper-wrapper */}
                        </div>
                        {/* swiper */}
                    </div>
                    {/* blog-content-wrapper */}
                </div>
            </section>
            {/*Blog-content Section ======================*/}
            {/*Subscription Section ======================*/}
            {/*Subscription Section ======================*/}
            {/* <Footer/> */}
        {/* </LanguageContext.Provider > */}
        </>
        
    )
}

export default Publisher
